var formatStaticUrl = function formatStaticUrl(_ref) {
  var url = _ref.url,
      npEnvironment = _ref.npEnvironment,
      version = _ref.version;
  return (url || '').replace('{envExceptNp}.', npEnvironment === 'np' ? '' : "".concat(npEnvironment, ".")).replace('{version}', version);
};

export default formatStaticUrl;